/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddQuestionCommandControllerAddQuestion201,
  AddQuestionDto,
  ArchiveTemplateCommandControllerArchiveTemplate200,
  CopyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation201,
  CopyTemplateToOrganisationDto,
  CreateTemplateCommandControllerCreateTemplate201,
  CreateTemplateDto,
  CreateTemplateVersionCommandControllerCreateVersion201,
  CreateTemplateVersionDto,
  GetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationParams,
  ImportTemplateCommandControllerImportTemplate201,
  ImportTemplateDto,
  PublishTemplateCommandControllerPublishTemplate200,
  TemplateListItemResponseDto,
  TemplateResponseDto,
  UpdateQuestionDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Create a new questionnaire template
 */
export const createTemplateCommandControllerCreateTemplate = (
  createTemplateDto: CreateTemplateDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateTemplateCommandControllerCreateTemplate201>({
    url: `/v1/questionnaire-templates`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTemplateDto,
    signal,
  });
};

export const getCreateTemplateCommandControllerCreateTemplateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplateCommandControllerCreateTemplate>>,
    TError,
    { data: CreateTemplateDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTemplateCommandControllerCreateTemplate>>,
  TError,
  { data: CreateTemplateDto },
  TContext
> => {
  const mutationKey = ["createTemplateCommandControllerCreateTemplate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTemplateCommandControllerCreateTemplate>>,
    { data: CreateTemplateDto }
  > = (props) => {
    const { data } = props ?? {};

    return createTemplateCommandControllerCreateTemplate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTemplateCommandControllerCreateTemplateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof createTemplateCommandControllerCreateTemplate>>
  >;
export type CreateTemplateCommandControllerCreateTemplateMutationBody =
  CreateTemplateDto;
export type CreateTemplateCommandControllerCreateTemplateMutationError = void;

/**
 * @summary Create a new questionnaire template
 */
export const useCreateTemplateCommandControllerCreateTemplate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTemplateCommandControllerCreateTemplate>>,
      TError,
      { data: CreateTemplateDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTemplateCommandControllerCreateTemplate>>,
  TError,
  { data: CreateTemplateDto },
  TContext
> => {
  return useMutation(
    getCreateTemplateCommandControllerCreateTemplateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Get all templates for an organisation or global templates
 */
export const getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation =
  (
    params?: GetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationParams,
    signal?: AbortSignal,
  ) => {
    return axiosClient<TemplateListItemResponseDto[]>({
      url: `/v1/questionnaire-templates`,
      method: "GET",
      params,
      signal,
    });
  };

export const getGetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationQueryKey =
  (
    params?: GetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationParams,
  ) => {
    return [
      `/v1/questionnaire-templates`,
      ...(params ? [params] : []),
    ] as const;
  };

export const getGetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
      >
    >,
    TError = void,
  >(
    params?: GetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationParams,
    options?: {
      query?: Partial<
        UseQueryOptions<
          Awaited<
            ReturnType<
              typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
            >
          >,
          TError,
          TData
        >
      >;
    },
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationQueryKey(
        params,
      );

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
        >
      >
    > = ({ signal }) =>
      getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation(
        params,
        signal,
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
  };

export type GetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
      >
    >
  >;
export type GetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationQueryError =
  void;

export function useGetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation<
  TData = Awaited<
    ReturnType<
      typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
    >
  >,
  TError = void,
>(
  params:
    | undefined
    | GetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation<
  TData = Awaited<
    ReturnType<
      typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
    >
  >,
  TError = void,
>(
  params?: GetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
            >
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation<
  TData = Awaited<
    ReturnType<
      typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
    >
  >,
  TError = void,
>(
  params?: GetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get all templates for an organisation or global templates
 */

export function useGetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation<
  TData = Awaited<
    ReturnType<
      typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
    >
  >,
  TError = void,
>(
  params?: GetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTemplatesByOrganisationQueryControllerGetTemplatesByOrganisation
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTemplatesByOrganisationQueryControllerGetTemplatesByOrganisationQueryOptions(
      params,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new version of a published template
 */
export const createTemplateVersionCommandControllerCreateVersion = (
  templateId: string,
  createTemplateVersionDto: CreateTemplateVersionDto,
  signal?: AbortSignal,
) => {
  return axiosClient<CreateTemplateVersionCommandControllerCreateVersion201>({
    url: `/v1/questionnaire-templates/${templateId}/versions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: createTemplateVersionDto,
    signal,
  });
};

export const getCreateTemplateVersionCommandControllerCreateVersionMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createTemplateVersionCommandControllerCreateVersion>
      >,
      TError,
      { templateId: string; data: CreateTemplateVersionDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<typeof createTemplateVersionCommandControllerCreateVersion>
    >,
    TError,
    { templateId: string; data: CreateTemplateVersionDto },
    TContext
  > => {
    const mutationKey = ["createTemplateVersionCommandControllerCreateVersion"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof createTemplateVersionCommandControllerCreateVersion>
      >,
      { templateId: string; data: CreateTemplateVersionDto }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return createTemplateVersionCommandControllerCreateVersion(
        templateId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CreateTemplateVersionCommandControllerCreateVersionMutationResult =
  NonNullable<
    Awaited<
      ReturnType<typeof createTemplateVersionCommandControllerCreateVersion>
    >
  >;
export type CreateTemplateVersionCommandControllerCreateVersionMutationBody =
  CreateTemplateVersionDto;
export type CreateTemplateVersionCommandControllerCreateVersionMutationError =
  void;

/**
 * @summary Create a new version of a published template
 */
export const useCreateTemplateVersionCommandControllerCreateVersion = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof createTemplateVersionCommandControllerCreateVersion>
      >,
      TError,
      { templateId: string; data: CreateTemplateVersionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<
    ReturnType<typeof createTemplateVersionCommandControllerCreateVersion>
  >,
  TError,
  { templateId: string; data: CreateTemplateVersionDto },
  TContext
> => {
  return useMutation(
    getCreateTemplateVersionCommandControllerCreateVersionMutationOptions(
      options,
    ),
    queryClient,
  );
};
/**
 * Creates a new questionnaire template with questions from a JSON payload. At least one question is required.
 * @summary Import a questionnaire template from JSON
 */
export const importTemplateCommandControllerImportTemplate = (
  importTemplateDto: ImportTemplateDto,
  signal?: AbortSignal,
) => {
  return axiosClient<ImportTemplateCommandControllerImportTemplate201>({
    url: `/v1/questionnaire-templates/import`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: importTemplateDto,
    signal,
  });
};

export const getImportTemplateCommandControllerImportTemplateMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importTemplateCommandControllerImportTemplate>>,
    TError,
    { data: ImportTemplateDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importTemplateCommandControllerImportTemplate>>,
  TError,
  { data: ImportTemplateDto },
  TContext
> => {
  const mutationKey = ["importTemplateCommandControllerImportTemplate"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importTemplateCommandControllerImportTemplate>>,
    { data: ImportTemplateDto }
  > = (props) => {
    const { data } = props ?? {};

    return importTemplateCommandControllerImportTemplate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportTemplateCommandControllerImportTemplateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof importTemplateCommandControllerImportTemplate>>
  >;
export type ImportTemplateCommandControllerImportTemplateMutationBody =
  ImportTemplateDto;
export type ImportTemplateCommandControllerImportTemplateMutationError = void;

/**
 * @summary Import a questionnaire template from JSON
 */
export const useImportTemplateCommandControllerImportTemplate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importTemplateCommandControllerImportTemplate>>,
      TError,
      { data: ImportTemplateDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof importTemplateCommandControllerImportTemplate>>,
  TError,
  { data: ImportTemplateDto },
  TContext
> => {
  return useMutation(
    getImportTemplateCommandControllerImportTemplateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Add a question to a template
 */
export const addQuestionCommandControllerAddQuestion = (
  templateId: string,
  addQuestionDto: AddQuestionDto,
  signal?: AbortSignal,
) => {
  return axiosClient<AddQuestionCommandControllerAddQuestion201>({
    url: `/v1/questionnaire-templates/${templateId}/questions`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addQuestionDto,
    signal,
  });
};

export const getAddQuestionCommandControllerAddQuestionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addQuestionCommandControllerAddQuestion>>,
    TError,
    { templateId: string; data: AddQuestionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addQuestionCommandControllerAddQuestion>>,
  TError,
  { templateId: string; data: AddQuestionDto },
  TContext
> => {
  const mutationKey = ["addQuestionCommandControllerAddQuestion"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addQuestionCommandControllerAddQuestion>>,
    { templateId: string; data: AddQuestionDto }
  > = (props) => {
    const { templateId, data } = props ?? {};

    return addQuestionCommandControllerAddQuestion(templateId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddQuestionCommandControllerAddQuestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof addQuestionCommandControllerAddQuestion>>
>;
export type AddQuestionCommandControllerAddQuestionMutationBody =
  AddQuestionDto;
export type AddQuestionCommandControllerAddQuestionMutationError = void;

/**
 * @summary Add a question to a template
 */
export const useAddQuestionCommandControllerAddQuestion = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addQuestionCommandControllerAddQuestion>>,
      TError,
      { templateId: string; data: AddQuestionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addQuestionCommandControllerAddQuestion>>,
  TError,
  { templateId: string; data: AddQuestionDto },
  TContext
> => {
  return useMutation(
    getAddQuestionCommandControllerAddQuestionMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Update a question in a template
 */
export const updateQuestionCommandControllerUpdateQuestion = (
  templateId: string,
  questionId: string,
  updateQuestionDto: UpdateQuestionDto,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/questionnaire-templates/${templateId}/questions/${questionId}`,
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    data: updateQuestionDto,
    signal,
  });
};

export const getUpdateQuestionCommandControllerUpdateQuestionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateQuestionCommandControllerUpdateQuestion>>,
    TError,
    { templateId: string; questionId: string; data: UpdateQuestionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateQuestionCommandControllerUpdateQuestion>>,
  TError,
  { templateId: string; questionId: string; data: UpdateQuestionDto },
  TContext
> => {
  const mutationKey = ["updateQuestionCommandControllerUpdateQuestion"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateQuestionCommandControllerUpdateQuestion>>,
    { templateId: string; questionId: string; data: UpdateQuestionDto }
  > = (props) => {
    const { templateId, questionId, data } = props ?? {};

    return updateQuestionCommandControllerUpdateQuestion(
      templateId,
      questionId,
      data,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateQuestionCommandControllerUpdateQuestionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof updateQuestionCommandControllerUpdateQuestion>>
  >;
export type UpdateQuestionCommandControllerUpdateQuestionMutationBody =
  UpdateQuestionDto;
export type UpdateQuestionCommandControllerUpdateQuestionMutationError = void;

/**
 * @summary Update a question in a template
 */
export const useUpdateQuestionCommandControllerUpdateQuestion = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateQuestionCommandControllerUpdateQuestion>>,
      TError,
      { templateId: string; questionId: string; data: UpdateQuestionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateQuestionCommandControllerUpdateQuestion>>,
  TError,
  { templateId: string; questionId: string; data: UpdateQuestionDto },
  TContext
> => {
  return useMutation(
    getUpdateQuestionCommandControllerUpdateQuestionMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Delete a question from a template
 */
export const deleteQuestionCommandControllerDeleteQuestion = (
  templateId: string,
  questionId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/questionnaire-templates/${templateId}/questions/${questionId}`,
    method: "DELETE",
    signal,
  });
};

export const getDeleteQuestionCommandControllerDeleteQuestionMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteQuestionCommandControllerDeleteQuestion>>,
    TError,
    { templateId: string; questionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteQuestionCommandControllerDeleteQuestion>>,
  TError,
  { templateId: string; questionId: string },
  TContext
> => {
  const mutationKey = ["deleteQuestionCommandControllerDeleteQuestion"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteQuestionCommandControllerDeleteQuestion>>,
    { templateId: string; questionId: string }
  > = (props) => {
    const { templateId, questionId } = props ?? {};

    return deleteQuestionCommandControllerDeleteQuestion(
      templateId,
      questionId,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteQuestionCommandControllerDeleteQuestionMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof deleteQuestionCommandControllerDeleteQuestion>>
  >;

export type DeleteQuestionCommandControllerDeleteQuestionMutationError = void;

/**
 * @summary Delete a question from a template
 */
export const useDeleteQuestionCommandControllerDeleteQuestion = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteQuestionCommandControllerDeleteQuestion>>,
      TError,
      { templateId: string; questionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteQuestionCommandControllerDeleteQuestion>>,
  TError,
  { templateId: string; questionId: string },
  TContext
> => {
  return useMutation(
    getDeleteQuestionCommandControllerDeleteQuestionMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Publish a questionnaire template
 */
export const publishTemplateCommandControllerPublishTemplate = (
  templateId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<PublishTemplateCommandControllerPublishTemplate200>({
    url: `/v1/questionnaire-templates/${templateId}/publish`,
    method: "PATCH",
    signal,
  });
};

export const getPublishTemplateCommandControllerPublishTemplateMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof publishTemplateCommandControllerPublishTemplate>
      >,
      TError,
      { templateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof publishTemplateCommandControllerPublishTemplate>>,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationKey = ["publishTemplateCommandControllerPublishTemplate"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof publishTemplateCommandControllerPublishTemplate>
      >,
      { templateId: string }
    > = (props) => {
      const { templateId } = props ?? {};

      return publishTemplateCommandControllerPublishTemplate(templateId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PublishTemplateCommandControllerPublishTemplateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof publishTemplateCommandControllerPublishTemplate>>
  >;

export type PublishTemplateCommandControllerPublishTemplateMutationError = void;

/**
 * @summary Publish a questionnaire template
 */
export const usePublishTemplateCommandControllerPublishTemplate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof publishTemplateCommandControllerPublishTemplate>
      >,
      TError,
      { templateId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof publishTemplateCommandControllerPublishTemplate>>,
  TError,
  { templateId: string },
  TContext
> => {
  return useMutation(
    getPublishTemplateCommandControllerPublishTemplateMutationOptions(options),
    queryClient,
  );
};
/**
 * @summary Archive a questionnaire template
 */
export const archiveTemplateCommandControllerArchiveTemplate = (
  templateId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<ArchiveTemplateCommandControllerArchiveTemplate200>({
    url: `/v1/questionnaire-templates/${templateId}/archive`,
    method: "PATCH",
    signal,
  });
};

export const getArchiveTemplateCommandControllerArchiveTemplateMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof archiveTemplateCommandControllerArchiveTemplate>
      >,
      TError,
      { templateId: string },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof archiveTemplateCommandControllerArchiveTemplate>>,
    TError,
    { templateId: string },
    TContext
  > => {
    const mutationKey = ["archiveTemplateCommandControllerArchiveTemplate"];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof archiveTemplateCommandControllerArchiveTemplate>
      >,
      { templateId: string }
    > = (props) => {
      const { templateId } = props ?? {};

      return archiveTemplateCommandControllerArchiveTemplate(templateId);
    };

    return { mutationFn, ...mutationOptions };
  };

export type ArchiveTemplateCommandControllerArchiveTemplateMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof archiveTemplateCommandControllerArchiveTemplate>>
  >;

export type ArchiveTemplateCommandControllerArchiveTemplateMutationError = void;

/**
 * @summary Archive a questionnaire template
 */
export const useArchiveTemplateCommandControllerArchiveTemplate = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof archiveTemplateCommandControllerArchiveTemplate>
      >,
      TError,
      { templateId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof archiveTemplateCommandControllerArchiveTemplate>>,
  TError,
  { templateId: string },
  TContext
> => {
  return useMutation(
    getArchiveTemplateCommandControllerArchiveTemplateMutationOptions(options),
    queryClient,
  );
};
/**
 * Creates a copy of an existing template (typically a global template) and assigns it to an organisation. All questions from the source template are copied to the new template.
 * @summary Copy a template to an organisation
 */
export const copyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation =
  (
    templateId: string,
    copyTemplateToOrganisationDto: CopyTemplateToOrganisationDto,
    signal?: AbortSignal,
  ) => {
    return axiosClient<CopyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation201>(
      {
        url: `/v1/questionnaire-templates/${templateId}/copy-to-organisation`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: copyTemplateToOrganisationDto,
        signal,
      },
    );
  };

export const getCopyTemplateToOrganisationCommandControllerCopyTemplateToOrganisationMutationOptions =
  <TError = void, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof copyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation
        >
      >,
      TError,
      { templateId: string; data: CopyTemplateToOrganisationDto },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof copyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation
      >
    >,
    TError,
    { templateId: string; data: CopyTemplateToOrganisationDto },
    TContext
  > => {
    const mutationKey = [
      "copyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation",
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof copyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation
        >
      >,
      { templateId: string; data: CopyTemplateToOrganisationDto }
    > = (props) => {
      const { templateId, data } = props ?? {};

      return copyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation(
        templateId,
        data,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type CopyTemplateToOrganisationCommandControllerCopyTemplateToOrganisationMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof copyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation
      >
    >
  >;
export type CopyTemplateToOrganisationCommandControllerCopyTemplateToOrganisationMutationBody =
  CopyTemplateToOrganisationDto;
export type CopyTemplateToOrganisationCommandControllerCopyTemplateToOrganisationMutationError =
  void;

/**
 * @summary Copy a template to an organisation
 */
export const useCopyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation =
  <TError = void, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof copyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation
          >
        >,
        TError,
        { templateId: string; data: CopyTemplateToOrganisationDto },
        TContext
      >;
    },
    queryClient?: QueryClient,
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof copyTemplateToOrganisationCommandControllerCopyTemplateToOrganisation
      >
    >,
    TError,
    { templateId: string; data: CopyTemplateToOrganisationDto },
    TContext
  > => {
    return useMutation(
      getCopyTemplateToOrganisationCommandControllerCopyTemplateToOrganisationMutationOptions(
        options,
      ),
      queryClient,
    );
  };
/**
 * @summary Get a questionnaire template by ID
 */
export const getTemplateByIdQueryControllerGetTemplateById = (
  templateId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<TemplateResponseDto>({
    url: `/v1/questionnaire-templates/${templateId}`,
    method: "GET",
    signal,
  });
};

export const getGetTemplateByIdQueryControllerGetTemplateByIdQueryKey = (
  templateId: string,
) => {
  return [`/v1/questionnaire-templates/${templateId}`] as const;
};

export const getGetTemplateByIdQueryControllerGetTemplateByIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
  >,
  TError = void,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
        >,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTemplateByIdQueryControllerGetTemplateByIdQueryKey(templateId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>>
  > = ({ signal }) =>
    getTemplateByIdQueryControllerGetTemplateById(templateId, signal);

  return {
    queryKey,
    queryFn,
    enabled: templateId !== null && templateId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTemplateByIdQueryControllerGetTemplateByIdQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>>
  >;
export type GetTemplateByIdQueryControllerGetTemplateByIdQueryError = void;

export function useGetTemplateByIdQueryControllerGetTemplateById<
  TData = Awaited<
    ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
  >,
  TError = void,
>(
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateByIdQueryControllerGetTemplateById<
  TData = Awaited<
    ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
  >,
  TError = void,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
          >,
          TError,
          Awaited<
            ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
          >
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateByIdQueryControllerGetTemplateById<
  TData = Awaited<
    ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
  >,
  TError = void,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a questionnaire template by ID
 */

export function useGetTemplateByIdQueryControllerGetTemplateById<
  TData = Awaited<
    ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
  >,
  TError = void,
>(
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<typeof getTemplateByIdQueryControllerGetTemplateById>
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetTemplateByIdQueryControllerGetTemplateByIdQueryOptions(
      templateId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
